export enum UserCategory {
  registered = 'registered', // registered to a specific country state ( can only sell in this state )
  nonRegistered = 'non-registered', // can sell in any states
}
